import * as form from '../form';

export const legalCriminalConvictions = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Has: form.branch(xitem.Has),
        IsReportedInAnotherSec: form.branch(xitem.IsReportedInAnotherSec),
        NatureOfAction: form.textarea(xitem.NatureOfAction),
        OffenseDate: form.datecontrol(xitem.OffenseDate),
        InvolvedViolence: form.branch(xitem.InvolvedViolence),
        InvolvedFirearms: form.branch(xitem.InvolvedFirearms),
        InvolvedExplosives: form.branch(xitem.InvolvedExplosives),
        InvolvedDrugs: form.branch(xitem.InvolvedDrugs),
        InvolvedAlcohol: form.branch(xitem.InvolvedAlcohol),
        Charges: form.collection(((xitem.Charges || {}).items || []).map((y) => {
          const yItem = y.Item || {};
          return {
            Item: {
              CourtCharge: form.text(yItem.CourtCharge),
              ChargeType: form.radio(yItem.ChargeType),
              ChargeTypeOtherExplanation: form.textarea(yItem.ChargeTypeOtherExplanation),
              CourtOutcome: form.text(yItem.CourtOutcome),
              CourtOutcomeOtherExplanation: form.textarea(yItem.CourtOutcomeOtherExplanation),
              ConvictedDate: form.datecontrol(yItem.ConvictedDate),
              SentenceJudgements: form.checkboxgroup(yItem.SentenceJudgements),
              SentenceJudgementOtherExplanation: form.textarea(yItem.SentenceJudgementOtherExplanation),
              ProbationDates: form.daterange(yItem.ProbationDates),
              IncarcerationDates: form.daterange(yItem.IncarcerationDates),
              GrantedParole: form.branch(yItem.GrantedParole),
              GrantedParoleDates: form.daterange(yItem.GrantedParoleDates),
            },
          };
        }), (xitem?.Charges?.branch)),
        CaseClosedDate: form.datecontrol(xitem.CaseClosedDate),
        CaseNotClosed: form.checkbox(xitem.CaseNotClosed),
        CaseNotClosedExplanation: form.textarea(xitem.CaseNotClosedExplanation),
        CourtName: form.text(xitem.CourtName),
        CourtAddress: form.location(xitem.CourtAddress),

      },
    };
  });
  return {
    // HasCriminalConvictions: form.branch(data.HasCriminalConvictions),
    List: form.collection(items, (data.List || {}).branch),
  };
};
